import { customElement } from 'lit/decorators.js';
import { html } from 'lit';
import { TabbedPageBase } from '../../pages/helpers/page-base';

@customElement('app-fabrication-purchase-orders')
export class AppFabricationPurchaseOrdersPage extends TabbedPageBase {
  protected async setActiveTabByHash() {
    // No tabs to activate
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div class="page-content">
        <div class="page-container">
          <div class="p-4 text-muted">
            <h4>Purchase Orders</h4>
            <p>Fabrication-related purchase orders will be available here in a future release.</p>
          </div>
        </div>
      </div>
    `;
  }

  meta() {
    return {
      title: () => 'Purchase Orders',
      description: 'Fabrication purchase orders'
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
}
